import afip from '../../../../Assets/img/DATAWEB.jpg';
import { imagesCompanias } from '../../../../Assets/imageCompania';
import { CompaniaLegacy, DescripcionLegacy, descripcionesDeCobertura } from './adapters';
import { adaptarSnapshot, ContextoPrecios } from './preciosBff';

/**
 * Armado de las cards de precios de auto, compartido por `/auto/precios` y `/retomar`.
 * Es el mismo codigo que vivia inline en `Pages/Auto/Precios.tsx`: moverlo no cambia nada de
 * lo que ve quien cotiza normal, y retomar pinta exactamente las mismas cards.
 */

type Pais = 'AR' | 'UY' | 'BR' | string | undefined;
type DescripcionCard = { Nombre: string; Descripcion: string; Aclaracion: string | null };

/** Los cinco textos cortos de la card. */
export const resumenDeCoberturas = (descripciones: Array<{ Nombre: string; Descripcion: string }>, pais: Pais): string[] => {
  const porNombre: { [nombre: string]: string } = {};
  descripciones.forEach((desc) => {
    porNombre[desc.Nombre.toUpperCase().trim()] = desc.Descripcion || 'No';
  });
  const de = (nombre: string, porDefecto = 'No') => porNombre[nombre.toUpperCase()] || porDefecto;
  if (pais === 'AR') {
    return [
      de('Cristales Laterales'),
      de('Daño Parcial por Accidente con franquicia', 'No aplica'),
      de('Cobertura en Exterior'),
      de('Auxilio Mecánico y Remolque'),
      de('Granizo'),
    ];
  }
  if (pais === 'UY') {
    return [de('Destrucción Total'), de('Deducible', 'No aplica'), de('Cobertura en exterior'), de('Auxilio mecánicos'), de('Granizo')];
  }
  return [];
};

/** Descripciones guardadas (bootstrap) de una cobertura, con "si"/"no" como los muestra la card. */
export const descripcionesParaCard = (
  guardadas: Record<string, DescripcionLegacy> | DescripcionLegacy[] | undefined | null,
  codigoCobertura: string,
  codigoCompania: string,
): DescripcionCard[] =>
  descripcionesDeCobertura(Object.values(guardadas || {}) as DescripcionLegacy[], codigoCobertura, codigoCompania).map((desc) => ({
    Nombre: desc.ItemDescripcion2Nombre,
    Descripcion: desc.Texto === 'si' ? 'Si' : desc.Texto === 'no' ? 'No' : desc.Texto,
    Aclaracion: desc.Aclaraciones ?? null,
  }));

/** Logo de la compania por nombre; en UY, el logo uruguayo si existe. */
export const logoDeCompania = (compania: string | undefined, pais: Pais): string => {
  if (!compania) return '';
  const nombre = compania.trim().toLowerCase();
  const comp = imagesCompanias.find((c) => c.nombreCompania.toLowerCase() === nombre);
  if (!comp) return '';
  if (pais === 'UY' && comp.imgRutaUy) return comp.imgRutaUy;
  return comp.imgRuta;
};

export const armarContextoPrecios = ({
  companias,
  descripciones,
  pais,
  sumaAseguradaIA,
}: {
  companias?: CompaniaLegacy[];
  descripciones: Record<string, DescripcionLegacy> | DescripcionLegacy[] | undefined | null;
  pais: Pais;
  sumaAseguradaIA?: string;
}): ContextoPrecios => ({
  companias: companias || [],
  logoDe: (codigo) => logoDeCompania(codigo, pais),
  afip,
  descripcionesDe: (codigoCobertura, codigoCompania) => descripcionesParaCard(descripciones, codigoCobertura, codigoCompania),
  resumenDe: (desc) => resumenDeCoberturas(desc, pais),
  sumaAseguradaFallback: sumaAseguradaIA ? Number(sumaAseguradaIA) : null,
});

export { adaptarSnapshot };
